import * as React from 'react';
import { AiScanningLogo } from 'components/Custom/AiScanningLogo';
import { Provider } from 'store/api/enums';
import { resolveProviderIconSrc } from 'utils/resolve-provider-icon-src';

export const isReceiptsProvider = (
  providerName?: string | null
): boolean => {
  if (!providerName?.trim()) return false;
  const n = providerName.toLowerCase().trim();
  return (
    n === Provider.RECEIPTS.toLowerCase() ||
    n === 'receipts' ||
    n.includes('receipt')
  );
};

export type ProviderIconProps = {
  providerName?: string | null;
  width?: number | string;
  height?: number | string;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
};

/**
 * Renders the correct provider mark. Receipts / AI Scanning always uses the
 * theme-aware SVG so it stays white in dark mode.
 */
export const ProviderIcon: React.FC<ProviderIconProps> = ({
  providerName,
  width = 25,
  height,
  alt,
  style,
  className,
}) => {
  if (isReceiptsProvider(providerName)) {
    return (
      <AiScanningLogo
        className={className}
        width={width}
        height={height ?? width}
        style={style}
        aria-label={alt || providerName || 'AI Scan Receipts & Bills'}
      />
    );
  }

  const src = resolveProviderIconSrc(providerName);
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt || providerName || ''}
      width={width}
      height={height ?? width}
      className={className}
      style={style}
    />
  );
};
